import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Flex, Text } from "@chakra-ui/react";
import { BillingInterval, PlanType } from "sdk/types";
import { monthlyPricesByIntervalAndPlan } from "~/constants";
import { Trans } from "~/utils/i18next";
import { PromoCodeSection } from "./PromoCodeSection";

interface Props {
  billingInterval: BillingInterval;
  fullPrice: number;
  type: PlanType;
}

export const InvoiceAndPromoCode: FC<Props> = ({
  billingInterval,
  fullPrice,
  type,
}) => {
  const { t } = useTranslation();

  const monthlyPrice =
    monthlyPricesByIntervalAndPlan[billingInterval][type].toFixed(2);

  return (
    <Flex direction="column" gap={2} w="full">
      <Flex align="center" justify="space-between">
        <Text variant="th-body3">
          {t(`planPayment.planInfo.${type}.title`)}
        </Text>
        <Text variant="th-body2">
          <Trans
            i18nKey="planPayment.planInfo.formattedPrice"
            values={{ price: monthlyPrice }}
          />
        </Text>
      </Flex>
      <Flex>
        <Text color="th.gray4" variant="th-body4">
          <Trans
            i18nKey={`planPayment.billingInterval.${billingInterval}.description`}
          />
        </Text>
      </Flex>
      <Flex align="center" justify="space-between">
        <Text variant="th-body2">{t(`planPayment.subtotal.label`)}</Text>
        <Text variant="th-body2">
          <Trans
            i18nKey="planPayment.subtotal.price"
            values={{ price: fullPrice }}
          />
        </Text>
      </Flex>
      <PromoCodeSection
        billingInterval={billingInterval}
        fullPrice={fullPrice}
        type={type}
      />
    </Flex>
  );
};
